import { defineComponent, defineAsyncComponent } from 'vue';
import { QBanner, QIcon } from 'quasar';
import { resolveChannel } from '../debugger/flowChannelConfig.js';
import { loadTouchpointEditor, resolveTouchpointEditorId } from '../touchpointEditors/registry.js';

/**
 * Host for channel touchpoint editors. Editors are auto-detected under touchpointEditors/.
 * This panel does not call list/save APIs.
 */
export default defineComponent({
    name: 'flow-v2-method-touchpoints-panel',
    components: { QBanner, QIcon },
    props: {
        flowId: { type: String, required: true },
        flowType: { type: String, default: 'FlowHeader' },
        projectId: { type: String, default: null },
        channelType: { type: String, default: 'Call' },
        channelConfig: { type: Object, default: null },
    },
    emits: ['open-project-releases'],
    data() {
        return {
            editorComponent: null,
        };
    },
    computed: {
        resolvedChannel() {
            const base = this.channelConfig || resolveChannel(this.channelType);
            if (base?.ChannelType)
                return base;
            return { ...(base || {}), ChannelType: this.channelType || 'Call' };
        },
        editorId() {
            return resolveTouchpointEditorId(this.resolvedChannel);
        },
    },
    watch: {
        editorId: {
            immediate: true,
            handler() {
                const loader = loadTouchpointEditor(this.resolvedChannel);
                this.editorComponent = loader ? defineAsyncComponent(loader) : null;
            },
        },
    },
    render() {
        if (!this.editorComponent) {
            return (
                <QBanner class="bg-grey-2" rounded>
                    {{
                        avatar: () => <QIcon name="mdi-information-outline" color="primary" />,
                        default: () => (
                            <div>
                                Channel: {this.channelType || '—'}
                                <div class="q-mt-sm">
                                    Touchpoint mapping is not configured for this channel.
                                </div>
                            </div>
                        ),
                    }}
                </QBanner>
            );
        }

        const Editor = this.editorComponent;
        return (
            <Editor
                flowId={this.flowId}
                flowType={this.flowType}
                projectId={this.projectId}
                channelType={this.channelType}
                onOpenProjectReleases={() => this.$emit('open-project-releases')}
            />
        );
    },
});
